<div class="file-list-section" *ngIf="uploadedFiles !== undefined  && uploadedFiles.length > 0">
    <ngx-datatable [rows]="uploadedFiles" [headerHeight]="52" [rowHeight]="52" [columnMode]="'force'"
        [scrollbarV]="true" class="primary-ngx-datatable-styling file-info-datatable">
        <ngx-datatable-column [width]="300" [frozenLeft]="true" [resizeable]="false" [draggable]="false"
            [cellClass]="'my-custom-cell-left'" [flexGrow]="1" prop="name" name="File Name">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <span [title]=row.fileName>
                    &nbsp;{{row.fileName !== null ? (row.fileName.length >= 30 ?
                    row.fileName.substring(0,30).trimRight() + '...' : row.fileName): ''}}
                </span>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [width]="220" [frozenLeft]="true" [resizeable]="false" [draggable]="false"
            [cellClass]="'my-custom-cell-left'" [flexGrow]="1" prop="name" name="Status">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <span>
                    <button *ngIf="row.status === fileImportStatusEnum.Success" class="status-style completed-icon"><i
                            class="fas fa-check-circle"></i> &nbsp;Completed</button>
                    <button *ngIf="row.status === fileImportStatusEnum.Error" class="status-style due-soon-icon"><i
                            class="fas fa-exclamation-triangle"></i> &nbsp;Completed with Errors</button>
                    <button *ngIf="row.status === fileImportStatusEnum.Warning" class="status-style in-progress-icon"><i
                            class="far fa-clock"></i>
                            &nbsp;Completed with Warning</button>
                    <button *ngIf="row.status === fileImportStatusEnum.SystemException"
                        class="status-style due-soon-icon"><i class="fas fa-exclamation-circle"></i> &nbsp;Invalid
                        Template</button>
                </span>
                <span class="downloadicon-margin" *ngIf="row.status === fileImportStatusEnum.Error">
                    <a data-toggle="tooltip" [title]="errorToolTip" (click)="downloadFile(row)">
                        <i class=" fas fa-download" aria-hidden="true"></i>
                    </a>
                </span>
                <span class="downloadicon-margin" *ngIf="row.status === fileImportStatusEnum.Warning">
                    <a data-toggle="tooltip" [title]="warningToolTip" (click)="downloadFile(row)">
                        <i class=" fas fa-download" aria-hidden="true"></i>
                    </a>
                </span>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column [width]="170" [frozenLeft]="true" [resizeable]="false" [draggable]="false"
            [cellClass]="'my-custom-cell-center'" [flexGrow]="1" prop="name" name="Rows Imported">
            <ng-template let-row="row" ngx-datatable-cell-template>
                &nbsp;<span>{{row.validRecord}}/{{row.totalRecords}}</span>
            </ng-template>
        </ngx-datatable-column>
        <ng-container *ngIf="fileType === 1">
            <ngx-datatable-column [width]="170" [frozenLeft]="true" [resizeable]="false" [draggable]="false"
                [cellClass]="'my-custom-cell-center'" [flexGrow]="1" prop="name" name="Total Wages">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span>
                        {{row.totalWage | currency : 'USD' : 'symbol' : '1.0-0'}}
                    </span>
                </ng-template>
            </ngx-datatable-column>
        </ng-container>
        <ngx-datatable-column [width]="250" [frozenLeft]="true" [resizeable]="false" [draggable]="false"
            [cellClass]="'my-custom-cell-left'" [flexGrow]="1" prop="name" name="Imported By">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <span [title]=row.uploadedBy>
                    &nbsp;{{row.uploadedBy != null ? (row.uploadedBy.length >= 35 ?
                    row.uploadedBy.substring(0,35).trimRight() + '...' : row.uploadedBy): ''}}
                </span>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column [width]="200" [frozenLeft]="true" [resizeable]="false" [draggable]="false"
            [cellClass]="'my-custom-cell-left'" [flexGrow]="1" prop="name" name="Imported On [UTC]">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <span [title]=row.updatedOn>
                    &nbsp;{{row.insertedOn | date:"MM/dd/yyyy HH:mm:ss"}}
                </span>
            </ng-template>
        </ngx-datatable-column>
    </ngx-datatable>
</div>